/**
 * Canonical URL helpers for city landing pages (Phase 1).
 * FR cities: /location-voiture/:slug (no /fr/ prefix).
 * EN cities: /en/car-rental/:slug.
 * AR cities: /ar/location-voiture/:slug.
 */

export const SEO_BASE_URL = 'https://rakb.ma';

/** Slugs reserved for programmatic hubs — not city pages. */
export const RESERVED_LOCATION_VOITURE_SLUGS = new Set([
  'longue-duree',
  'pas-cher',
  'luxe',
  'aeroport',
  'categorie',
]);

export const isCityLandingSlug = (slug: string): boolean =>
  Boolean(slug) && !RESERVED_LOCATION_VOITURE_SLUGS.has(slug);

export {
  cityPathFr,
  cityPathEn,
  cityPathAr,
  cityPath,
  cityCanonicalUrl,
  cityHreflangCluster,
  type SEOLocale,
} from '@/lib/seo/locale-seo';

/** Legacy programmatic FR path — use only for 301 redirects. */
export const legacyFrCityPath = (slug: string): string => `/fr/location-voiture/${slug}`;
